// The rates and the acceptance window as the admins configured them, read from the public endpoint —
// brokers and valuers may not call `/api/admin/settings`, and none of these numbers is a secret.
import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { PublicSettings } from './types';

const DEFAULTS = { acceptWindowMinutes: 60, commissionRate: 0.005, serviceFeeRate: 0.05 };

export function usePublicSettings() {
  const q = useQuery({ queryKey: ['public', 'settings'], queryFn: () => api.get<PublicSettings>('/api/public/settings'), staleTime: 60_000 });
  return {
    data: q.data,
    acceptWindowMinutes: q.data?.acceptWindowMinutes ?? DEFAULTS.acceptWindowMinutes,
    commissionRate: q.data?.rates?.commission ?? DEFAULTS.commissionRate,
    serviceFeeRate: q.data?.rates?.serviceFee ?? DEFAULTS.serviceFeeRate,
  };
}
